import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { mapCatalogProduct } from '@/stores/transformProductApiResponse';
import { AppDispatch } from '@/configureStore';
import type * as Types from '@/pages/mijn-carel-lurvink/catalogus/stores/types';

interface ProductsThunkRequest {
  apiUrl: string;
}

const fetchProductsThunk = createAsyncThunk<Types.ApiResponse | undefined, ProductsThunkRequest>(
  'productSearchSlice/fetch',
  async ({ apiUrl }, { rejectWithValue }) => {
    try {
      const response = await fetch(apiUrl);
      const data = await response.json();
      return data;
    } catch (e: any) {
      return rejectWithValue(e.message);
    }
  }
);

export const productSearchSlice = createSlice({
  name: 'productSearch',
  initialState: {
    entities: {},
    loading: 'idle',
    facetsOpen: false
  },
  reducers: {
    toggleFacetsOpen: (state) => {
      return {
        ...state,
        facetsOpen: !state.facetsOpen
      };
    },
    openFacets: (state) => {
      return {
        ...state,
        facetsOpen: true
      };
    },
    closeFacets: (state) => {
      return {
        ...state,
        facetsOpen: false
      };
    }
  },
  extraReducers: (builder) => {
    builder.addCase(fetchProductsThunk.fulfilled, (state, action) => {
      return {
        ...state,
        loading: 'fulfilled',
        entities: {
          ...action.payload,
          results: action?.payload?.results?.map((product: any) => mapCatalogProduct(product))
        }
      };
    });

    builder.addCase(fetchProductsThunk.pending, (state) => {
      state.loading = 'pending';
    });

    builder.addCase(fetchProductsThunk.rejected, (state) => {
      state.loading = 'failed';
    });
  }
});

export const { toggleFacetsOpen, openFacets, closeFacets } = productSearchSlice.actions;

export function getProducts(dispatch: AppDispatch) {
  return async function ({ apiUrl }: { apiUrl: string }) {
    await dispatch(fetchProductsThunk({ apiUrl }));
  };
}
